"use strict";

import {
    default as React,
    Component,
 } from 'react';
import PropTypes from 'prop-types';

import {
    scale
} from 'kaidoo-chart/core';

import Axis from '../axis/axis';
import CommonProps from '../commonProps';

class Grid extends Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        type: 'x',
        gridAxisClassName: 'react-d3-core__grid_axis',
        ...CommonProps
    };

    static propTypes = {
        height: PropTypes.number.isRequired,
        width: PropTypes.number.isRequired,
        margins: PropTypes.object.isRequired,
        type: PropTypes.oneOf(['x', 'y']).isRequired,
        x: PropTypes.func,
        y: PropTypes.func,
        scale: PropTypes.oneOf(['linear', 'identity', 'sqrt', 'pow', 'log', 'quantize', 'quantile', 'ordinal', 'band', 'time']).isRequired,
        xScaleSet: PropTypes.func.isRequired,
        yScaleSet: PropTypes.func.isRequired,
        axisConfig: PropTypes.object.isRequired,
        gridConfig: PropTypes.object.isRequired,

    };

    render() {

        let {
            height,
            width,
            margins,
            type,
            x,
            y,
            xScaleSet,
            yScaleSet,
            axisConfig,
            gridConfig,
        } = this.props;

        let {borderExcess, customStyle} = gridConfig;

        let scaleType = this.props.scale;

        let gridAxis;
        let t;

        let range;

        borderExcess = [
            (borderExcess?(borderExcess[0]?borderExcess[0]:0):0),
            (borderExcess?(borderExcess[1]?borderExcess[1]:0):0)];

        let newDomain;
        let newScaleSet;

        let tickValues = axisConfig.ticks.values;
        let tickFormat = axisConfig.ticks.format;
        let tickCount = axisConfig.ticks.count;

        let sizeInner, sizeOuter = null;
        let tickOrient = null;

        if(type === 'x') {
            newDomain = xScaleSet.domain();
            range = xScaleSet.range();

            newScaleSet = xScaleSet;

            t = `translate(${(gridConfig.shift ? gridConfig.shift : 0)}, 
                ${(height - margins.bottom - margins.top + borderExcess[0])})`;

            sizeInner = (Math.abs(yScaleSet.range()[1]-yScaleSet.range()[0]) + borderExcess[0] + borderExcess[1]);
            sizeOuter = sizeInner;

            tickOrient = 'top';
        }

        if(type === 'y') {
            newDomain = yScaleSet.domain();
            range = yScaleSet.range();

            newScaleSet = yScaleSet;

            t = `translate(${-borderExcess[0]}, ${(gridConfig.shift ? gridConfig.shift : 0)})`;

            sizeInner = (Math.abs(xScaleSet.range()[1]-xScaleSet.range()[0]) + borderExcess[0] + borderExcess[1]);
            sizeOuter = sizeInner;

            tickOrient = 'right';
        }

        if (scaleType == 'band' || scaleType == 'ordinal') {
            newDomain = [0, this.props.data.length];
            tickCount = this.props.data.length;

            let tempScaleSet = {
                scale: 'linear',
                domain: newDomain,
                range: range,
            };
            newScaleSet = scale(tempScaleSet);
        }

        let tickConfig = {
            sizeInner: sizeInner,
            sizeOuter: sizeOuter,
            values: tickValues,
            format: tickFormat,
            count: tickCount,
            padding: 0,
            orient: tickOrient,
            tickClassName: gridConfig.className,
        };

        // if grid axis don't pass customize ticks.
        gridAxis = <Axis
            showAxis= {false}
            height= {height}
            width= {width}
            margins= {margins}
            scaleSet = {newScaleSet}
            type={`grid${type}`}
            proxy = {x}
            tickConfig={tickConfig}
            axisClassName={`${type}-grid-axis`}
            customStyle={customStyle}
        />;

        return (
            <g transform = {t}>
                {gridAxis}
            </g>
        )
    }
}

export {Grid as default};